__turbopack_context__.v({
  "tags": "RenderTags-module__b6SBMa__tags",
  "tags-item": "RenderTags-module__b6SBMa__tags-item",
});
